
  import { Address } from '@/scripts/address';
  import { ADDRESS_FIELDS } from '@/constants/addresses';
  export default {
    props: {
      buttonText: { type: String, required: true },
      disableAutoFocus: { type: Boolean, default: false },
      nextPage: { type: String, required: true },
      searchLabel: { type: String, required: true },
      skipLink: { type: String, default: null },
      skipText: { type: String, default: null }
    },
    data () {
      return {
        address: null,
        addressFields: ADDRESS_FIELDS,
        formDisabled: false
      };
    },
    computed: {
      canonicalAddress () {
        return this.address ? new Address(this.address).canonical : null;
      },
      product () {
        return this.$store.getters['utils/getMeta'].product;
      },
      search () {
        return this.$store.getters['search/get'];
      }
    },
    methods: {
      proceed (address) {
        this.address = address;
        if (this.address === null) return;

        this.formDisabled = true;
        this.$cookies.set(`bonkers-ie-${this.product}-capture-point`, this.address);
        this.$router.push(this.nextPage);
      },
      clickedSkip () {
        this.$store.dispatch('matomo/trackCTAClick', {name: 'Clicked Skip this Step on broadband'});
      }
    }
  };
